export const getI18nCoutry = (country: string, i18n: any, countries: any) => {
  const getCapitalizedLang = () =>
    i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1);
  if (country) {
    const countryI18n = countries.find((gen: any) => gen.code === country);
    if (countryI18n) return countryI18n[`description${getCapitalizedLang()}`];
    return country;
  }
  return "";
};

export const getI18nCountryByKey = (
  country: string,
  i18n: any,
  countryByKey: any
) => {
  const getCapitalizedLang = () =>
    i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1);
  if (country) {
    const countryI18n = countryByKey[country];
    if (countryI18n) return countryI18n[`description${getCapitalizedLang()}`];
    return country;
  }
  return "";
};
